<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/S5gnta/tc-custom/9781423632443.jpg?1720018439251" alt="This image is the cover for the book French Cook: Cream Puffs & Eclairs"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">French Cook: Cream Puffs & Eclairs
      </h1>
      <p class="bookDescription body article font2">
        <p><b>A step-by-step, French cooking class on choux pastry with savory and sweet recipes to try—by the award-winning food writer and author of <i>Tart Love</i>.</b><br/><br/> The second book in The French Cook series, following <i>The French Cook: Sauces</i>, classically French trained author Holly Herrick dips into the marvelously versatile world of choux pastry, or pâte à choux. The buttery, nutty, even-flavor of this dough invites myriad flavors, in both sweet and savory categories and in many shapes—cream puffs, éclairs, rings, and more.<br/><br/> Whether it be a savory petit éclair filled with an avocado mousse layered with bacon and tomatoes, choux “gnocchi” with a buttered herb sauce, three cheese gougères with black pepper, a sweet Dreamsicle orange cream puff with a dark chocolate sauce, a salted caramel macadamia ice cream filled profiterole with a warm caramel sauce, an Almond Joy cream puff, or a hot-from-the-fryer beignet with a cool, fresh raspberry sauce, taste delights are found all along the way. Holly also provides tips and recipes for assembling classic cream puff cakes such as the croquembouche and Gâteau St. Honoré.<br/><br/> Holly dedicates the front of the book to the art of demystifying the “puff,” making choux pastry an easy and accessible medium for every cook, novice, professional or anyone in-between. There is a chapter on sweet sauces to go along with the sweet cream puffs and éclairs and expert tips on piping, baking and garnishing these uniquely French delights.<br/><br/><b>“An exploration deep into the world of choux and quickly debunks the myth that this best-known French pastry is something too complicated for the home baker…<i>Une délice</i>!”—<i>Huffington Post</i></b></p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Holly Herrick
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Gibbs Smith
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?eb04984a